/** Matches backend `FulfillmentMode` / catalog JSON. */
export const CERTIFICATE_FULFILLMENT_MODE_SLUGS = [
  "digital_only",
  "physical_only",
  "digital_and_physical",
] as const;

export type CertificateFulfillmentModeSlug = (typeof CERTIFICATE_FULFILLMENT_MODE_SLUGS)[number];

export const DEFAULT_CERTIFICATE_FULFILLMENT_MODES_ALLOWED: CertificateFulfillmentModeSlug[] = [
  ...CERTIFICATE_FULFILLMENT_MODE_SLUGS,
];
